(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-corporate"] && !Shopify.designMode) return;
  try {
    
(() => {
function initialiseCorporate(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const gallery = root.querySelector('#pp-corp-gallery-dialog');
  const image = root.querySelector('#pp-corp-gallery-image');
  let trigger;
  root.querySelectorAll('.ppc-photo-button').forEach(button => button.addEventListener('click', () => {
    trigger = button;
    image.src = button.dataset.image;
    image.alt = button.querySelector('img').alt;
    root.querySelector('#pp-corp-gallery-title').textContent = button.dataset.title;
    root.querySelector('#pp-corp-gallery-description').textContent = button.dataset.caption;
    gallery.showModal();
    document.body.classList.add('pp-corp-dialog-open');
  }));
  root.querySelector('.ppc-dialog-close').addEventListener('click', () => gallery.close());
  gallery.addEventListener('click', event => {
    const rect = gallery.getBoundingClientRect();
    if (event.target === gallery && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) gallery.close();
  });
  gallery.addEventListener('close', () => {
    document.body.classList.remove('pp-corp-dialog-open');
    trigger?.focus({preventScroll:true});
  });
  const more = root.querySelector('.ppc-more-questions');
  const faqs = root.querySelector('#pp-corp-more-faqs');
  more.addEventListener('click', () => {
    const open = more.getAttribute('aria-expanded') !== 'true';
    more.setAttribute('aria-expanded', String(open));
    faqs.hidden = !open;
    more.firstChild.textContent = (open ? more.dataset.fewer : more.dataset.more) + ' ';
  });
  if ('IntersectionObserver' in window) {
    let heroVisible = true, quoteVisible = false;
    const mobile = root.querySelector('.ppc-mobile-quote');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.id === 'pp-corp-quote') quoteVisible = entry.isIntersecting;
        else heroVisible = entry.isIntersecting;
      });
      mobile.classList.toggle('ppc-is-hidden', heroVisible || quoteVisible);
    }, {threshold:0.05});
    observer.observe(root.querySelector('#pp-corp-quote'));
    observer.observe(root.querySelector('.ppc-hero-panel'));
  }
}
const initialise = () => document.querySelectorAll('.pp-corporate').forEach(initialiseCorporate);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise); else initialise();
document.addEventListener('shopify:section:load', initialise);
document.addEventListener('shopify:section:unload', () => document.body.classList.remove('pp-corp-dialog-open'));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-create-steps"] && !Shopify.designMode) return;
  try {
    
(() => {
  const guides = new Map();

  function initialiseGuide(root) {
    if (guides.has(root)) return;
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const players = new Map();
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const player = players.get(entry.target);
            if (!player) return;
            player.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
            player.sync();
          });
        }, { threshold: [0, 0.35] })
      : null;

    root.querySelectorAll('.step-video-live').forEach(figure => {
      const video = figure.querySelector('video');
      const button = figure.querySelector('[data-pp-video-toggle]');
      if (!video || !button) return;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      button.hidden = false;

      const player = {
        inView: !observer,
        userPaused: false,
        userStarted: false,
        pending: false,
        allowed() {
          return !document.hidden && this.inView && !this.userPaused
            && (this.userStarted || (observer && !motionPreference.matches));
        },
        updateButton() {
          const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
          button.querySelector('[data-pp-video-label]').textContent = label;
          button.setAttribute('aria-label', label + ': ' + button.dataset.videoLabel);
          button.dataset.playing = String(!video.paused);
        },
        sync() {
          if (!this.allowed()) {
            video.pause();
            this.updateButton();
            return;
          }
          if (!video.paused || this.pending) return;
          this.pending = true;
          Promise.resolve(video.play()).then(() => {
            this.pending = false;
            if (!this.allowed()) video.pause();
            this.updateButton();
          }).catch(() => {
            this.pending = false;
            this.updateButton();
          });
        }
      };

      button.addEventListener('click', () => {
        if (video.paused) {
          player.userPaused = false;
          player.userStarted = true;
          player.inView = true;
        } else {
          player.userPaused = true;
          player.userStarted = false;
        }
        player.sync();
      }, { signal: events.signal });
      video.addEventListener('play', () => player.updateButton(), { signal: events.signal });
      video.addEventListener('pause', () => player.updateButton(), { signal: events.signal });
      players.set(figure, player);
      player.updateButton();
      if (observer) observer.observe(figure);
    });

    document.addEventListener('visibilitychange', () => {
      players.forEach(player => player.sync());
    }, { signal: events.signal });
    motionPreference.addEventListener('change', () => {
      players.forEach(player => {
        player.userStarted = false;
        player.sync();
      });
    }, { signal: events.signal });

    guides.set(root, () => {
      events.abort();
      observer?.disconnect();
      root.querySelectorAll('video').forEach(video => video.pause());
      guides.delete(root);
    });
  }

  function initialise(container) {
    if (container.matches?.('.pp-create-steps')) initialiseGuide(container);
    container.querySelectorAll('.pp-create-steps').forEach(initialiseGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    guides.forEach((dispose, root) => {
      if (event.target.contains(root)) dispose();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
